import api from '../config/api';

const configuracionAniversarioLaboralService = {
  async obtenerConfiguracion(empresaId) {
    try {
      const response = await api.get(`/configuracion-aniversarios-laborales/empresa/${empresaId}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener configuración de aniversarios laborales:', error);
      return {
        success: false,
        error: error.response?.data?.error || 'Error al obtener configuración de aniversarios laborales',
      };
    }
  },

  async actualizarConfiguracion(empresaId, { activo, anios, dias_anticipacion }) {
    try {
      const response = await api.put(`/configuracion-aniversarios-laborales/empresa/${empresaId}`, {
        activo: Boolean(activo),
        anios,
        dias_anticipacion,
      });
      return response.data;
    } catch (error) {
      console.error('Error al guardar configuración de aniversarios laborales:', error);

      if (error.response?.status === 422) {
        return {
          success: false,
          error: 'Datos de entrada inválidos',
          details: error.response.data.details,
        };
      }

      return {
        success: false,
        error: error.response?.data?.error || 'Error al guardar configuración de aniversarios laborales',
      };
    }
  },
};

export default configuracionAniversarioLaboralService;
